var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionLoved(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M31.795 15.897c0 8.78-7.118 15.897-15.898 15.897S0 24.677 0 15.897C0 7.117 7.117 0 15.897 0c8.78 0 15.898 7.117 15.898 15.897",
    transform: "translate(-203 -1271) translate(39 1271) translate(164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA5F5F",
    d: "M14.107 3.193C13.282.786 10.677-.491 8.762.176 7.425.64 6.594 1.996 6.492 3.59 5.437 2.4 3.952 1.85 2.616 2.315.702 2.982-.569 5.607.256 8.013c.848 2.477 3.01 3.147 4.956 3.954 1.454.603 3.293 1.072 4.747 1.675 1.03-1.83 2.444-3.794 3.473-5.624.819-1.456 1.317-2.949.675-4.825M31.193 9.457c1.072-2.12.22-4.706-1.48-5.567-1.186-.6-2.637-.281-3.771.685.106-1.485-.497-2.843-1.683-3.443-1.7-.86-4.29-.012-5.36 2.106-1.104 2.182-.136 4.076.598 5.913.548 1.373 1.438 2.919 1.986 4.29 1.898-.492 4.14-.813 6.038-1.307 1.512-.393 2.836-1.025 3.672-2.677",
    transform: "translate(-203 -1271) translate(39 1271) translate(164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M9.066 15.527s6.655-.246 13.802 2.958c0 0-.985 7.64-8.626 5.915-7.64-1.725-5.176-8.873-5.176-8.873",
    transform: "translate(-203 -1271) translate(39 1271) translate(164)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FA5F5F",
    d: "M16.834 23.295c-.192.628-1.57.763-3.078.302-1.507-.462-2.574-1.345-2.381-1.973.192-.628 1.57-.762 3.077-.3 1.508.46 2.574 1.344 2.382 1.971",
    transform: "translate(-203 -1271) translate(39 1271) translate(164)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionLoved);
export default __webpack_public_path__ + "static/media/reactionLoved.658d3856.svg";
export { ForwardRef as ReactComponent };